export default {
  dialogText: {
    width: '300px',
    height: '30px'
  },
  instructorTable: {
    background: '#fff',
    padding: '10px',
    cellSpacing: '40px',
    textAlign: 'center',
    width:'100%'
  },
  thead: {
    borderBottom: '0.02px solid grey',
    color: '#576271',
    fontSize: '20px'
  },
  instructorTitle: {
    background: '#fff',
    fontSize: '20px',
    color: '#576271',
    height: '50px',
    padding:'10px',
    paddingLeft:'20px',
    fontWeight:'bold'
  }
};
